import React, { Component } from 'react';
import T from 'prop-types';
// redux
import { connect } from 'react-redux';
// components
import FormField from 'components/ReduxFormFields/FormField/FormField';
import { Field } from 'redux-form';
// regional date handling
import { getCurrentCountryCode } from 'selectors/regionalDateSelectors';
import { shouldUseDDMMFormat } from 'utils/regionalDateHelper';
// assets
import './UserProfilePQADate.scss';
// translate
import { FormattedMessage } from 'react-intl';

class UserProfilePQADate extends Component {

  handleDateChange = ({ target: { name, value } }) => {
    const { countryCode } = this.props;
    const useDDMM = shouldUseDDMMFormat(countryCode);
    const valuesValidations = {
      month: () => {
        if (value.length >= 2) {
          if (useDDMM) {
            // In DD/MM/YYYY format, month is second, focus to year
            this.pqaYear.focus();
          } else {
            // In MM/DD/YYYY format, month is first, focus to day
            this.pqaDay.focus();
          }
        }
      },
      day: () => {
        if (value.length >= 2) {
          if (useDDMM) {
            // In DD/MM/YYYY format, day is first, focus to month
            this.pqaMonth.focus();
          } else {
            // In MM/DD/YYYY format, day is second, focus to year
            this.pqaYear.focus();
          }
        }
      },
    };

    const logicName = name.split('.')[1];
    valuesValidations[logicName]();
  };

  renderUSFormat = (fieldProps) => (
    <>
      <Field
        name="pqa_date.month"
        getReference={(field) => { this.pqaMonth = field; }}
        maxLength={2}
        component={FormField}
        onChange={this.handleDateChange}
        type="text"
        pattern="[0-9]*"
        className="mr-5 mb-0"
        placeholder="MM"
        {...fieldProps}
      />
      <span>/</span>
      <Field
        name="pqa_date.day"
        getReference={(field) => { this.pqaDay = field; }}
        maxLength={2}
        component={FormField}
        onChange={this.handleDateChange}
        type="text"
        pattern="[0-9]*"
        className="mr-5 ml-5 mb-0"
        placeholder="DD"
        {...fieldProps}
      />
      <span>/</span>
      <Field
        name="pqa_date.year"
        getReference={(field) => { this.pqaYear = field; }}
        maxLength={4}
        component={FormField}
        type="text"
        pattern="[0-9]*"
        className="ml-5 mb-0"
        placeholder="YYYY"
        {...fieldProps}
      />
    </>
  );

  renderNonUSFormat = (fieldProps) => (
    <>
      <Field
        name="pqa_date.day"
        getReference={(field) => { this.pqaDay = field; }}
        maxLength={2}
        component={FormField}
        onChange={this.handleDateChange}
        type="text"
        pattern="[0-9]*"
        className="mr-5 mb-0"
        placeholder="DD"
        {...fieldProps}
      />
      <span>/</span>
      <Field
        name="pqa_date.month"
        getReference={(field) => { this.pqaMonth = field; }}
        maxLength={2}
        component={FormField}
        onChange={this.handleDateChange}
        type="text"
        pattern="[0-9]*"
        className="mr-5 ml-5 mb-0"
        placeholder="MM"
        {...fieldProps}
      />
      <span>/</span>
      <Field
        name="pqa_date.year"
        getReference={(field) => { this.pqaYear = field; }}
        maxLength={4}
        component={FormField}
        type="text"
        pattern="[0-9]*"
        className="ml-5 mb-0"
        placeholder="YYYY"
        {...fieldProps}
      />
    </>
  );

  render() {
    const { fieldProps, countryCode } = this.props;
    const useDDMM = shouldUseDDMMFormat(countryCode);
    return (
      <label className="UserProfilePQADate">
        <span className="input-label"><FormattedMessage id="component.userProfile.pqaDate" /></span>
        <div className="pqa flex align-center justify-start">
          {useDDMM ? this.renderNonUSFormat(fieldProps) : this.renderUSFormat(fieldProps)}
        </div>
      </label>
    );
  }
}

UserProfilePQADate.propTypes = {
  fieldProps: T.object,
  countryCode: T.string,
};

export default connect(
  (state) => ({
    countryCode: getCurrentCountryCode(state),
  })
)(UserProfilePQADate);
